import React from 'react';
import {FormattedMessage} from "react-intl";

const OrderType1ExpandedView = (props) => {

    let colorValue = props.pcbParams.pcbColor;
    let surfaceValue = props.pcbParams.surfaceFinish;
    let copperValue = props.pcbParams.copperWeight;
    let goldFingerValue = props.pcbParams.goldFinger;
    let flyingProbeValue = props.pcbParams.flyingProbe;
    let castellatedValue = props.pcbParams.castellatedHoles;

    let edgeRails = props.itemDetails.edgeRails;
    let equationCalX;
    let equationCalY;
    let panelByJLCPCBX = props.pcbParams.panelByJLCPCB_X;
    let panelByJLCPCBY = props.pcbParams.panelByJLCPCB_Y;

    console.log("edgeRails value in OrderType1ExpandedView ===> " , edgeRails);

    if (edgeRails === 1) {

        const edgeRailValue = 20;

        if((props.pcbParams.width * panelByJLCPCBX) > (props.pcbParams.length * panelByJLCPCBY) || (props.pcbParams.width * panelByJLCPCBX) === (props.pcbParams.length * panelByJLCPCBY)) {
            equationCalY = Math.round((panelByJLCPCBY*props.pcbParams.length+edgeRailValue)*100)/100;
            equationCalX = Math.round((panelByJLCPCBX*props.pcbParams.width)*100)/100;
        } else {
            equationCalX = Math.round((panelByJLCPCBX*props.pcbParams.width+edgeRailValue)*100)/100;
            equationCalY = Math.round((panelByJLCPCBY*props.pcbParams.length)*100)/100;
        }
    } else {
        console.log("edgeRails value ===> " , edgeRails);
        equationCalX = Math.round((panelByJLCPCBX*props.pcbParams.width)*100)/100;
        equationCalY = Math.round((panelByJLCPCBY*props.pcbParams.length)*100)/100;
    }

    let buildTime = props.itemDetails.chargeDetails.buildTime !== '' ? props.itemDetails.chargeDetails.buildTime : '';

    let dimensions = props.pcbParams.width !== '' && props.pcbParams.length !== '' ?
        (Math.floor(props.pcbParams.width*10) /10).toFixed(1)+"mm*"+(Math.floor(props.pcbParams.length *10) /10).toFixed(1)+"mm" : '';

    let color = colorValue === 0 ? <FormattedMessage id="app.home-content.pcb-service.service-green"
                                                     defaultMessage="Green"
                                                     description=""/> :
        colorValue === 1 ? <FormattedMessage id="app.home-content.pcb-service.service-red"
                                             defaultMessage="Red"
                                             description=""/> :
            colorValue === 2 ? <FormattedMessage id="app.home-content.pcb-service.service-yellow"
                                                 defaultMessage="Yellow"
                                                 description=""/> :
                colorValue === 3 ? <FormattedMessage id="app.home-content.pcb-service.service-blue"
                                                     defaultMessage="Blue"
                                                     description=""/> :
                    colorValue === 4 ? <FormattedMessage id="app.home-content.pcb-service.service-white"
                                                         defaultMessage="White"
                                                         description=""/> :
                        colorValue === 5 ? <FormattedMessage id="app.home-content.pcb-service.service-black"
                                                             defaultMessage="Black"
                                                             description=""/> : '';

    let surface = surfaceValue === 0 ? <FormattedMessage id="app.pcb-quotation.pcb-surface-finish-1"
                                                         defaultMessage="HASL(with lead)"
                                                         description=""/>:
                  surfaceValue === 1 ? <FormattedMessage id="app.pcb-quotation.pcb-surface-finish-2"
                                               defaultMessage="LeadFree HASL+RoHS"
                                               description=""/> :
                  surfaceValue === 2 ? <FormattedMessage id="app.pcb-quotation.pcb-surface-finish-3"
                                                   defaultMessage="ENIG-RoHS"
                                                   description=""/> : '';
    let copperWeight =  copperValue === 1 ? "35 μm" :
                        copperValue === 2 ? "70 μm" : '';

    let goldFingers =   goldFingerValue === 0 ? "面取り無し" :
                        goldFingerValue === 2 ? "面取りあり（45°）" : '';
    let materialDetails = props.pcbParams.materialDetails === 0 ?
                                            <FormattedMessage id="app.pcb-quotation.pcb-material-details-standard-tg"
                                                              defaultMessage="FR4 - Standard Tg 140C"
                                                              description=""/> : '';
    let flyingProbe =   flyingProbeValue === 1 ? <FormattedMessage id="app.pcb-quotation.pcb-flying-probe-fully-test"
                                                                 defaultMessage="Fully Test"
                                                                 description=""/> :
                        flyingProbeValue === 2 ? <FormattedMessage id="app.pcb-quotation.pcb-flying-probe-not-test"
                                                   defaultMessage="Not Test"
                                                   description=""/> : '';
    let castellated = castellatedValue === 0 ? <FormattedMessage id="app.pcb-quotation.pcb-castellated-holes-no"
                                                                 defaultMessage="No"
                                                                 description=""/> :
        <FormattedMessage id="app.pcb-quotation.pcb-castellated-holes-yes"
                          defaultMessage="Yes"
                          description=""/>;
    return(

        <div className="cart-item-detail">
            <div className="cart-item-detail-header">
                {/*<div className="item-details">PCB Order Details</div>*/}
            </div>
            <div>
                <div>
                    <small>

                        <div>
                                    <span className="cart-item-detail-span">
                                        <FormattedMessage id="app.order.expanded.layers"
                                                          defaultMessage="Layers"
                                                          description=""/>
                                         : &nbsp;</span>
                            {props.pcbParams.layer}<br/>
                        </div>
                        <div>
                                    <span className="cart-item-detail-span">
                                         <FormattedMessage id="app.order.expanded.dimensions"
                                                           defaultMessage="Dimensions"
                                                           description=""/>
                                         : &nbsp;</span>
                            {dimensions}<br/>
                        </div>
                        <div>
                                    <span className="cart-item-detail-span">
                                        <FormattedMessage id="app.order.expanded.quantity"
                                                          defaultMessage="PCB Qty"
                                                          description=""/>
                                         : &nbsp;</span>
                            {props.pcbParams.qty}<br/>
                        </div>
                        <div>
                                    <span className="cart-item-detail-span">
                                        <FormattedMessage id="app.order.expanded.thickness"
                                                          defaultMessage="PCB Thickness"
                                                          description=""/>
                                         : &nbsp;</span>
                            {props.pcbParams.thickness}<br/>
                        </div>
                        <div>
                                    <span className="cart-item-detail-span">
                                        <FormattedMessage id="app.order.expanded.impedance"
                                                          defaultMessage="Impedance"
                                                          description=""/>
                                         : &nbsp;</span>いいえ
                            <br/>
                        </div>
                        <div>
                                    <span className="cart-item-detail-span">
                                         <FormattedMessage id="app.order.expanded.pcb-color"
                                                           defaultMessage="PCB Color"
                                                           description=""/>
                                         : &nbsp;</span>
                            {color}<br/>
                        </div>
                        <div>
                                    <span className="cart-item-detail-span">
                                         表面処理
                                         : &nbsp;</span>
                            {surface}<br/>
                        </div>
                        <div>
                                    <span className="cart-item-detail-span">
                                         <FormattedMessage id="app.order.expanded.copper-weight"
                                                           defaultMessage="Copper Weight"
                                                           description=""/>
                                         : &nbsp;</span>
                            {copperWeight}<br/>
                        </div>
                        <div>
                                    <span className="cart-item-detail-span">
                                         <FormattedMessage id="app.order.expanded.gold fingers"
                                                           defaultMessage="Gold Fingers"
                                                           description=""/>
                                         : &nbsp;</span>
                            {goldFingers}<br/>
                        </div>
                        <div>
                                    <span className="cart-item-detail-span">
                                         <FormattedMessage id="app.order.expanded.material-details"
                                                           defaultMessage="Material Details"
                                                           description=""/>
                                         : &nbsp;</span>
                            {materialDetails}<br/>
                        </div>
                        <div>
                                    <span className="cart-item-detail-span">
                                         <FormattedMessage id="app.order.expanded.panel-by"
                                                           defaultMessage="Panel By JLCPCB (X/Y)"
                                                           description=""/>
                                        : &nbsp;</span>
                            {props.pcbParams.panelFlag === 0 ? "いいえ" : "("+equationCalX+"mm) x ("+equationCalY+"mm)"}<br/>
                        </div>
                        <div>
                                    <span className="cart-item-detail-span">
                                         <FormattedMessage id="app.order.expanded.weight"
                                                           defaultMessage="Weight"
                                                           description=""/>
                                         : &nbsp;</span>
                            {props.itemDetails.chargeDetails.weight}g<br/>
                        </div>
                        <div>
                                    <span className="cart-item-detail-span">
                                         <FormattedMessage id="app.order.expanded.probe-test"
                                                           defaultMessage="Flying Probe Test"
                                                           description=""/>
                                         : &nbsp;</span>
                            {flyingProbe}<br/>
                        </div>
                        <div>
                                    <span className="cart-item-detail-span">
                                         <FormattedMessage id="app.order.expanded.castellated-holes"
                                                           defaultMessage="Castellated Holes"
                                                           description=""/>
                                         : &nbsp;</span>
                            {castellated}<br/>
                        </div>
                    </small>
                </div>
            </div>
        </div>
    )
};
export default OrderType1ExpandedView;



// WEBPACK FOOTER //
// ./src/components/Site/Cart/CartItem/CartItemDetails/OrderType1ExpandedView/OrderType1ExpandedView.js